import type { LandingDict } from './en';

const nl: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "App maken", org: "My Org", pricing: 'Prijzen', privacy: "Privacy", contact: "Contact", language: 'Taal' },
  hero: {
    titlePre: 'Jouw lokale\n',
    titleMark: 'AI-krachtpatser.',
    titlePost: '',
    sub: "Maak van expertkennis, spreadsheets en vergaderingen antwoorden, grafieken en presentaties. Niets verlaat je Mac.",
    watch: "Bekijk de film van 2 min",
    pill: "Nieuwste versie",
    chip: "Wifi uit · 0 bytes verzonden",
    badges: { offline: "Werkt offline", server: "Jouw server, niet de onze", free: "Gratis beginnen" },
    reqs: 'Vereist een Mac met Apple Silicon · minimaal 16 GB geheugen · vanaf 32 GB draai je de grotere aanbevolen modellen',
  },
  stats: {
    free: 'Gratis',
    freeSub: 'Alle Chat Apps, modeldownloads en updates — altijd',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: 'bytes naar de cloud als de AI op deze Mac draait',
    langsSub: 'interfacetalen, van Nederlands tot 日本語',
  },
  film: { kicker: 'De film', title: 'Zie Estha in actie.', watchOnYouTube: 'Bekijk op YouTube', trouble: 'Lukt afspelen niet? Bekijk op YouTube ↗' },
  overview: {
    kicker: 'Eén app, vier manieren van werken',
    title: 'Van chat naar agents,\nnaar apps voor je hele team.',
    explore: 'Ontdek',
    chat: { title: 'Chat Apps', desc: 'AI-experts gebaseerd op zorgvuldig samengestelde kennisbanken — studieboeken, playbooks en domeinexpertise.', tag: 'Altijd gratis' },
    agentic: { title: 'Agentic Apps', desc: 'Taakgerichte AI-agents die complex werk van begin tot eind afhandelen.', tag: '{n} en het worden er meer' },
    build: { title: "App maken", desc: 'Maak met Quick Bot van je eigen materiaal een Chat App, of stel flows samen op het Playground-canvas.', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: 'De eigen app-omgeving van je organisatie, in je eigen huisstijl, met gecontroleerde apps en beheerde toegang.', tag: 'Enterprise' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: 'Expert-AI met echte kennis.',
    freePill: 'Altijd gratis',
    lede: 'Elke Chat App heeft een eigen kennisbank, geïndexeerd op je eigen Mac.',
    feats: {
      kb: { title: 'Lokale kennisbanken', desc: 'Bij installatie wordt de kennisbank lokaal aangemaakt — antwoorden komen uit zorgvuldig samengesteld materiaal.' },
      files: { title: 'Je eigen bestanden', desc: 'Voeg afbeeldingen, PDF, DOCX, TXT of MD toe — lange documenten doorzoekt Estha slim.' },
      browse: { title: 'Bladeren, vastzetten, bewaren', desc: 'Categorieën van Assessment tot Carrière, NEW-labels voor nieuwe apps en ⌘K om alles te doorzoeken.' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n} Agentic Apps.\nEn er komen er meer.',
    lede: 'Van een spreadsheet, een PDF, een opname of een idee naar een kant-en-klare grafiek, presentatie, document of prototype — privé op je Mac.',
    seeThem: 'Bekijk ze in actie',
  },
  build: {
    kicker: 'App maken',
    title: 'Maak je eigen Chat App.\nGewoon op je Mac.',
    lede: 'Maak van je eigen bestanden een Chat App — lokaal geïndexeerd, gepubliceerd zodra jij er klaar voor bent.',
    quick: {
      badge: 'Aanbevolen',
      desc: 'Upload een kennisbank en schrijf een systeemprompt, publiceer daarna. Ideaal om materiaal snel om te zetten in een vraag-en-antwoordbot.',
      items: ['Formulier van één pagina, in een paar stappen klaar', 'Kennisbank-Q&A direct beschikbaar', 'Ingebouwde promptsjablonen ter inspiratie'],
    },
    advanced: {
      title: 'Geavanceerd · Playground',
      desc: 'Visuele node-editor om vrij meerdere nodes, vertakkingen, AB-tests en trefwoordroutering samen te stellen.',
      items: ['Node-canvas', 'Meerdere nodes / vertakking / AB-test', 'Fijnmazige velden & foutopsporing'],
    },
    guideTitle: 'Een lokale AI-bouwhulp helpt je op weg.',
    guideText: 'Vertel wat je app moet doen en de bouwhulp laat zien welke nodes je sleept en hoe je ze verbindt. Bouwen zit bij Premium inbegrepen.',
  },
  private: {
    kicker: 'Privé van ontwerp',
    title: "Geen cloud voor je data.\nGeen tracking van je werk.",
    lede: "Jij bepaalt waar de AI draait. Estha kiest standaard het juiste model per functie — en je wisselt op elk moment van model in de app.",
    boundary: "Datagrens = jouw netwerk",
    local: { title: 'Op deze Mac', desc: 'Volledig offline, niets verlaat dit apparaat. Gebruikt het geheugen van deze computer.', best: 'Ideaal voor Macs met voldoende geheugen' },
    server: { title: 'Op mijn Estha Server', desc: 'Verplaats het zware werk naar een krachtigere Mac in je netwerk en houd deze Mac licht.', best: 'Ideaal voor laptops en Macs met weinig geheugen' },
    cluster: { desc: 'Verbind met een Mac Studio Cluster om zware inferentie uit te besteden, terwijl je data on-premises blijft.', best: 'Vindt Estha Studio Master-knooppunten in je netwerk automatisch' },
    models: {
      every: 'Draait op elke ondersteunde Mac',
      whisper: "Whisper voor transcriptie",
      recommended: 'De aanbevolen modellen',
      larger: "Grotere Qwen- en Gemma-modellen",
      vision: "Visiemodellen voor afbeeldingen",
      open: 'Open modellen, geoptimaliseerd voor Apple Silicon',
      openItems: ['Modellen downloaden en wisselen in de app', 'Speciale code- en embeddingmodellen', 'Modeldownloads altijd gratis'],
    },
  },
  org: {
    kicker: 'My Org',
    title: 'De eigen AI-appomgeving van je organisatie.',
    lede: 'Een eigen plek in Estha, in de huisstijl van je organisatie, met de apps die zij voor haar mensen heeft goedgekeurd.',
    signIn: 'Inloggen bij My Org Admin',
    talk: 'Praat met het Estha-team',
    feats: {
      review: { title: 'Controle vóór publicatie', desc: 'Elke nieuwe app, update of verwijdering gaat eerst langs een beheerder. Bij een afwijzing volgt altijd schriftelijke feedback.' },
      access: { title: 'Toegang per groep of persoon', desc: 'Bepaal precies wie welke app ziet — per afdeling, team of persoon.' },
      brand: { title: 'Jouw merk, in de app', desc: 'Naam, welkomstbericht, logo, banner en themakleur van je organisatie — eerst bekijken, dan live.' },
    },
  },
  pricing: {
    kicker: 'Lidmaatschap',
    title: 'Begin gratis. Ontgrendel alles wanneer jij er klaar voor bent.',
    free: { name: 'Gratis', sub: 'Altijd gratis.', items: ["Alle Chat Apps", 'Documentverwerking, voor altijd gratis', 'Modeldownloads, software en updates — altijd gratis'] },
    premium: {
      name: 'Premium', flag: '14 dagen gratis proberen', firstYear: 'eerste jaar',
      sub: 'Daarna $30/jaar. Bevestig je e-mailadres en probeer het 14 dagen gratis.',
      items: ['Alles uit Gratis', 'Alle huidige en toekomstige Agentic Apps', 'Chat App-bouwer — lokale chatbots maken, bewerken, previewen, opslaan en publiceren'],
      cta: 'Start de proefperiode in de app',
    },
    enterprise: {
      name: 'Enterprise', price: 'Op aanvraag', sub: 'Voor organisaties die Estha uitrollen naar hun teams.',
      items: ['Alles uit Premium', 'Aangepaste Chat Apps en Agentic Apps voor je team', 'Estha Server-appfunctionaliteit', 'My Org-appomgeving en My Org Admin'],
    },
  },
  faq: {
    title: 'Goed om te weten\nvoor je downloadt.',
    spec: { chip: 'Chip', memory: 'Geheugen', memMin: 'Minimaal 16 GB', memRec: '32 GB+ voor de aanbevolen modellen', languages: 'Talen', langsVal: '13 interfacetalen', version: 'Nieuwste versie' },
    qa: [
      { q: 'Verlaat er iets mijn Mac?', a: 'Als de AI op deze Mac draait, werkt alles volledig offline — er verlaat niets je computer. Kies je een Estha Server of een Mac Studio Cluster, dan gaat het werk alleen naar die machine in je eigen netwerk.' },
      { q: "Waarvoor is een internetverbinding nodig?", a: "Maar een paar dingen: inloggen en je e-mail verifiëren voor de Premium-proef, modellen downloaden en controleren op updates. Je prompts, bestanden en resultaten worden nooit geüpload — zodra een model is gedownload, werkt de AI volledig offline." },
      { q: 'Wat is gratis en wat is Premium?', a: 'Alle Chat Apps, Documentverwerking, modeldownloads en updates zijn gratis. Premium ontgrendelt alle huidige en toekomstige Agentic Apps plus de Chat App-bouwer, met een gratis proefperiode van 14 dagen.' },
      { q: 'Welke AI-modellen gebruikt Estha?', a: 'Toonaangevende open-source modellen zoals Qwen en Gemma, plus Whisper voor transcriptie, via de MLX-engine van Apple. Je downloadt en wisselt ze gewoon in de app.' },
      { q: 'Kan ik mijn eigen app maken?', a: 'Ja. Met Quick Bot maak je in een paar stappen van maximaal drie bestanden een Chat App met kennisbank. Of gebruik het node-canvas van Playground voor vertakkingen, AB-tests en quizzen. Een lokale bouwhulp helpt je onderweg.' },
      { q: 'Hoe rollen organisaties Estha uit?', a: 'Met Enterprise beheren admins gebruikers en groepen in My Org Admin en keuren ze elke app goed voordat die live gaat. Leden krijgen in Estha een eigen My Org-omgeving in de huisstijl van hun organisatie. Neem contact op via {email}.' },
    ],
  },
  final: { title: 'Klaar om AI lokaal te draaien?', reqs: 'Draait op elke Mac met Apple Silicon · minimaal 16 GB RAM' },
  footer: {
    tagline: 'Jouw lokale AI-krachtpatser — on-device, aangedreven door MLX, privé van ontwerp.',
    product: 'Product', createApp: 'App maken', pricing: 'Prijzen',
    orgs: "My Org", signIn: 'Inloggen bij My Org Admin',
    security: "Beveiliging", changelog: "Wijzigingen", docs: "Documentatie", support: "Support",
    company: 'Bedrijf', privacy: 'Privacybeleid', terms: 'Gebruiksvoorwaarden',
    rights: '© 2026 Estha. Alle rechten voorbehouden.',
  },
  proof: { press: "Bekend van", voices: "Wat teams zeggen" },
  contact: {
    title: "Mail het Estha-team", copy: "E-mailadres kopiëren", copied: "Gekopieerd",
    gmail: "Schrijven in Gmail", mailApp: "Openen in Mail-app",
    subject: "Vraag over Estha for Mac",
  },
  share: {
    button: "Delen", title: "Estha delen",
    sub: "Kies een kaart en post hem – of stuur gewoon de link.",
    style: "Kaart", size: "Formaat",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "Privacy" },
    landscape: "Liggend", portrait: "Staand",
    shareImage: "Afbeelding delen…", download: "Afbeelding downloaden", copyImage: "Afbeelding kopiëren", copied: "Gekopieerd",
    copyLink: "Link kopiëren", link: "Link", postTo: "Delen op",
    email: "E-mail",
    text: "Estha draait open-source AI-modellen volledig op je Mac – privé, offline en gratis te downloaden.",
    cardCta: "Gratis download voor Macs met Apple Silicon",
    close: "Sluiten",
  },
  apps: {
    dataAnalyst: { name: 'Data-analist', description: 'Upload CSV-/Excel-bestanden en stel vragen in natuurlijke taal. Genereert automatisch grafieken, statistische analyses en data-inzichten — allemaal lokaal verwerkt op je Mac.', tags: ['CSV / Excel', 'Automatische grafieken', 'Zoekopdracht in natuurlijke taal', 'EN / 中文'] },
    pptMaker: { name: 'PPT Maker', description: 'Beschrijf het onderwerp van je presentatie en ontvang een professioneel gestructureerde PowerPoint-presentatie. Een AI-pijplijn in meerdere stappen genereert een outline, inhoud per dia en een verzorgd .pptx-bestand.', tags: ['.pptx-uitvoer', 'Automatische lay-out', 'Pijplijn met meerdere stappen'] },
    pdfReader: { name: 'PDF-lezer', description: 'Open een PDF en stel er vragen over. Elk antwoord is gebaseerd op het document, met klikbare citaten die naar de exacte bronpassage springen — alles lokaal verwerkt op je Mac.', tags: ['PDF-vragen', 'Verifieerbare citaten', 'Selectie bevragen', '100% lokaal'] },
    documentProcessing: { name: 'Documentverwerking', description: 'Jouw alles-in-één documentexpert. Stel blogposts, socialmediateksten, juridische clausules en zakelijke documenten vanaf nul op. Bewerk en optimaliseer bestaande bestanden, vertaal tussen talen en controleer inhoud op kwaliteit — allemaal privé op je Mac.', tags: ['Opstellen & schrijven', 'Bewerken & optimaliseren', 'Vertalen', 'Beoordelen & controleren'] },
    meetingIntelligence: { name: 'Meeting Intelligence', description: 'Neem vergaderingen op, transcribeer en analyseer ze met AI. Genereer automatisch notulen, actiepunten en belangrijke beslissingen — volledig privé, want audio verlaat nooit je apparaat.', tags: ['Transcriptie', 'Notulen', 'Actiepunten', '100% privé'] },
    vibeCoding: { name: 'Vibe Coding: Prototype', description: 'Maak interactieve previews met AI. Beschrijf een interface in gewone taal, krijg een klikbaar prototype en blijf erop doorontwikkelen. Levert één op zichzelf staand .html-bestand, volledig lokaal gegenereerd op je Mac.', tags: ['Eén .html-bestand', 'Interactieve preview', 'Klikken om te bewerken', '100% lokaal'] },
    translate: { name: "Vertalen", description: "Vertaal tekst en Word-, tekst- of Markdown-documenten met een gedeelde woordenlijst die je termen consistent houdt, volledig lokaal verwerkt op je Mac.", tags: ["Tekst & documenten", ".docx / .txt / .md", "Woordenlijst", "100% lokaal"] },
  },
  screens: {
    chat: [
      { label: 'Door de store bladeren', caption: 'Bladeren, installeren, vastzetten — altijd gratis' },
      { label: 'Installeren', caption: 'Kennisbanken worden bij installatie lokaal aangemaakt' },
      { label: 'Vragen', caption: 'Antwoorden op basis van het eigen playbook' },
    ],
    build: [
      { label: 'App maken', caption: 'Quick Bot of Geavanceerd — allebei klaar om te chatten' },
      { label: 'Quick Bot', caption: 'Upload een kennisbank. Schrijf een prompt. Publiceer.' },
      { label: 'Playground', caption: 'Nodes, vertakkingen en kennis — visueel' },
      { label: 'Gepubliceerd', caption: 'Gepubliceerd en klaar om mee te chatten' },
    ],
    analyst: [
      { label: 'Stel een vraag', caption: 'Bevraag je data in gewone taal' },
      { label: 'Analyseren', caption: 'Geanalyseerd op je Mac' },
      { label: 'Grafiek & inzicht', caption: 'Het antwoord, de grafiek en hoe het tot stand kwam' },
    ],
    ppt: [
      { label: 'Instellen', caption: "Onderwerp, dia's, taal, toon, thema" },
      { label: 'Outline controleren', caption: 'Pas de outline aan voordat er iets wordt gegenereerd' },
      { label: 'Presentatie bekijken', caption: 'Een kant-en-klare, bewerkbare .pptx — op je Mac' },
    ],
    pdf: [
      { label: 'Open een PDF', caption: 'Papers, rapporten, handleidingen en scans' },
      { label: 'Lezen', caption: 'Lokaal gelezen, pagina voor pagina' },
      { label: 'Antwoord met bron', caption: 'Elk antwoord wijst naar de exacte passage' },
    ],
    doc: [
      { label: 'Selecteer een passage', caption: 'Selecteer tekst en zeg wat je wilt' },
      { label: 'Herschrijven', caption: 'Direct in het document herschreven' },
      { label: 'Accepteren of afwijzen', caption: 'Herschrijven, oppoetsen, vertalen — accepteer of wijs af' },
    ],
    meeting: [
      { label: 'Opnemen', caption: 'Live transcript, op deze Mac' },
      { label: 'Kies uitvoer', caption: 'Kies wat er gemaakt wordt' },
      { label: 'Samenvatting', caption: 'Besluiten en actiepunten, voor je uitgeschreven' },
      { label: 'Actiepunten', caption: 'Eigenaren en deadlines, met onderbouwing' },
    ],
    vibe: [
      { label: 'Beschrijven', caption: 'Beschrijf een interface in gewone taal' },
      { label: 'Genereren', caption: 'Volledig op deze Mac gebouwd' },
      { label: 'Prototype', caption: 'Klikbaar, met versies, één .html-bestand' },
      { label: 'Klikken om te bewerken', caption: 'Selecteer een onderdeel en zeg wat er anders moet' },
    ],
    translate: [
      { label: "Tekst vertalen", caption: "Paarse woorden komen uit je woordenlijst" },
      { label: "Document vertalen", caption: ".docx, .txt of .md — het origineel blijft ongewijzigd" },
      { label: "Woordenlijst", caption: "Je woordenlijst houdt elke term consistent" },
    ],
    private: [
      { label: 'Op deze Mac', caption: 'Volledig offline. Niets verlaat dit apparaat.' },
      { label: 'Mac Studio Cluster', caption: 'Zwaardere modellen — on-premises' },
    ],
    org: [
      { label: 'Org-appomgeving', caption: 'Eigen huisstijl, apps voor het team' },
      { label: 'Enterprise-abonnement', caption: 'Leden openen alleen apps die jij vrijgeeft' },
    ],
  },
};

export default nl;
